import { render, staticRenderFns } from "./DashboardDataQuality.vue?vue&type=template&id=84f78ca8&scoped=true"
import script from "./DashboardDataQuality.vue?vue&type=script&lang=js"
export * from "./DashboardDataQuality.vue?vue&type=script&lang=js"
import style0 from "./DashboardDataQuality.vue?vue&type=style&index=0&id=84f78ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f78ca8",
  null
  
)

export default component.exports